import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { XFieldComponent } from '../x-field/x-field.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'x-select',
  templateUrl: 'x-select.component.html',
  styleUrls: ['./x-select.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => XSelectComponent), multi: true }
  ]
})
export class XSelectComponent extends XFieldComponent {

  constructor(
    protected matSnackBar: MatSnackBar
  ) {
    super(matSnackBar);
  }
}
